<h2 mat-dialog-title>Enter Member</h2>
<mat-dialog-content class="mat-typography">
    <mat-form-field style="width: 100%">
        <input  matInput placeholder="Nom de l'élément"
                [(ngModel)]="LineDec.mMemberName">
    </mat-form-field>

    <table cellspacint="0"><tr>
        <td><mat-form-field class="multitable"><input disabled matInput placeholder="Quantity:" value="0" size="3"></mat-form-field></td>
        <td><mat-form-field class="multitable"><input disabled matInput placeholder="Tag count:" value="0" ></mat-form-field></td>
        <td><mat-form-field class="multitable"><input disabled matInput placeholder="Copy number:" value="0" ></mat-form-field></td>
    </tr><tr>
        <td></td>
        <td><mat-form-field class="multitable"><input disabled matInput placeholder="Member qty on tag:" value="0" ></mat-form-field></td>
        <td></td>
    </tr></table>
    <div>
        <label>Bar mark :</label>
        <mat-radio-group [disabled]="true" style="display: flex; flex-direction: column">
                <mat-radio-button value="1">Enter manually</mat-radio-button>
                <mat-radio-button value="2">Auto Alphabetical</mat-radio-button>
                <mat-radio-button value="3">Inter-member auto numb</mat-radio-button>
                <mat-radio-button value="4">Auto numeric</mat-radio-button>
                <mat-radio-button value="5">Disabled</mat-radio-button>
        </mat-radio-group>
    </div>
    <div>
        <label>Member type :</label>
        <mat-radio-group
            style="display: flex; flex-direction: column"
            [(ngModel)]="LineDec.mMemberType">
            <mat-radio-button [value]='0'>Assembled</mat-radio-button>
            <mat-radio-button [value]='1'>Cut and bent</mat-radio-button>
            <mat-radio-button [value]='2'>Cut lenght</mat-radio-button>
        </mat-radio-group>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close (click)="closeDialog()">Cancel</button>
  <button mat-raised-button [mat-dialog-close]="true" cdkFocusInitial (click)="validerDialog()">OK</button>
</mat-dialog-actions>
